import PatientList from "@/views/clinic/patientlist/PatientList"
export const patientlist = {
    path: '/patientlist',
    name: 'PatientList',
    component: PatientList
  }


// WEBPACK FOOTER //
// ./src/router/index/clinic/patientlist/index.js